import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useLocation,Link } from 'react-router-dom';
import { Box, Typography, CircularProgress, Alert,Button} from '@mui/material';
import { ErrorOutline, ArrowBack } from '@mui/icons-material';
const PaymentSuccess = () => {
  const location = useLocation();
  const [status, setStatus] = useState('Checking...');
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
 const registrationPath = '/techsummit2025'; 
  useEffect(() => {
    // 1. Extract registration ID from URL query parameters
    const params = new URLSearchParams(location.search);
    const registrationId = params.get('registration_id');

    if (!registrationId) {
      setStatus('Error');
      setLoading(false);
      return;
    }

    // 2. Poll/Check the backend API for status confirmation
    const checkStatus = async () => {
      try {
        // Call your backend API running on port 5000
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/techsummit2025/check-status?registrationId=${registrationId}`
        );
        
        setStatus(response.data.status);
        setData(response.data);

        // Optional: If status is still 'Pending', you might set up a short delay and retry (polling).
        // For simplicity, we assume the webhook has fired almost immediately.
        
      } catch (error) {
        console.error("Failed to fetch registration status:", error);
        setStatus('Error');
      } finally {
        setLoading(false);
      }
    };

    checkStatus();
  }, [location.search]); // Depend on URL search change

  if (loading) {
    return (
      <Box sx={{ p: 4, textAlign: 'center' }}>
        <CircularProgress />
        <Typography variant="h6" sx={{ mt: 2 }}>Verifying Payment Confirmation...</Typography>
        <Typography variant="body2">This may take a moment while the webhook processes.</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ maxWidth: 600, mx: 'auto', mt: 6, p: 4, boxShadow: 3, borderRadius: 3 }}>
      {status === 'Paid' ? (
        <>
          <Typography variant="h4" color="success.main" sx={{ mb: 2 }}>
            Registration Confirmed! 🎉
          </Typography>
          <Typography variant="body1">
            Thank you, **{data.name}**, for registering for the Tech Summit 2025.
          </Typography>
          <Alert severity="success" sx={{ mt: 3 }}>
            Your payment for **${(data.amount || '—')}** has been successfully recorded. A confirmation email has been sent to **{data.email}**.
          </Alert>
        </>
      ) : status === 'Pending' ? (
        <Alert severity="warning">
          Payment is pending confirmation. If this persists, please contact support with your registration ID: {data.registrationId}.
        </Alert>
      ) : (
        <Alert severity="error">
          An error occurred, or your registration was not found. Please contact support.
        </Alert>
      )}
       <Button 
            variant="contained" 
            color="primary" 
            size="large"
            startIcon={<ArrowBack />}
            component={Link} 
            to={registrationPath} 
        >
            Return to Tech Summit
        </Button>
    </Box>
  );
};

export default PaymentSuccess;